import jobsReportMutations from "./mutations.js";
import jobsReportActions from "./actions.js";
import jobsReportGetters from "./getters.js";

export default {
  namespaced: true,
  state() {
    return {

    };
  },
  mutations: jobsReportMutations,
  actions: jobsReportActions,
  getters: jobsReportGetters,
};
